import React, { useEffect, useState } from "react";
import "./AsicTech.css";

import { useInView } from "react-intersection-observer";
import { Player } from "@lottiefiles/react-lottie-player";
import { motion } from "framer-motion";

import BannerZoom from "./BannerZoom";
import chip1 from "./images/chip1.jpg";
import chip2 from "./images/chip2.jpg";
import chip3 from "./images/chip3.jpg";
import animation1 from "./lottieFiles/WorkingMan.json";
import lottie10 from "./lottieFiles/EmulLottie5.json";
import circle5 from "./lottieFiles/BackGround6.json";

import DesignVeriOne from "./DesignVeriOne";
import DesignVeriTwo from "./DesignVeriTwo";
import AsicCard from "./AsicCard";
import Popup from "./Popup";
import AmsDataOne from "./AmsDataOne";

const DesignVerification = () => {
  const images = [chip1, chip2, chip3];
  const heading1 = "Design Verification";
  const heading2 =
    "Our team has expertise in simulators, debugging tools, formal verifiers, and hardware accelerators from all the major EDA tool suppliers.";

  const [isAnimate, setIsAnimate] = useState(false);

  const [ref, inView] = useInView({});
  const [ref1, inView1] = useInView({});
  const [ref2, inView2] = useInView({});
  const [ref3, inView3] = useInView({});
  const [ref4, inView4] = useInView({});
  const [ref5, inView5] = useInView({});
  const [ref6, inView6] = useInView({});
  const [ref7, inView7] = useInView({});

  const variants1 = {
    initial: { opacity: 0, x: 400 },
    visible: { opacity: 1, x: 0 },
  };
  const variants2 = {
    initial: { opacity: 0, x: -400 },
    visible: { opacity: 1, x: 0 },
  };
  const variants3 = {
    initial: { opacity: 0, x: -350 },
    visible: { opacity: 1, x: 0 },
  };

  useEffect(() => {
    if (inView) {
      setIsAnimate(true);
    } else {
      setIsAnimate(false);
    }
  }, [inView]);

  const [isPopupVisible, setIsPopupVisible] = useState(false);
  const [selectedWords, setSelectedWords] = useState([]);

  const [wordsState, setWordsState] = useState({
    Methodology: [
      "UVM",
      "OVM",
      "RM",
      "C-based",
      "System C",
      "UPF based",
      "GLS",
    ],
    Subsystem: [
      "ARM",
      "DSP",
      "Graphics",
      "Display",
      "Camera",
      "Security",
      "CPU",
    ],
    IPs: [
      "PCI-E",
      "Ethernet",
      "NVMe",
      "USB",
      "MIPI",
      "DDR",
      "WLAN",
      "SDIO",
      "FlexRay",
    ],
    AMS: [
      "Behavioral Modelling",
      "CO-simulation",
      "WREAL",
      "System verification",
    ],
  });

  const openPopup = (wordsArray) => {
    setSelectedWords(wordsArray);
    setIsPopupVisible(true);
  };

  const closePopup = () => {
    setIsPopupVisible(false);
  };

  const handleSubmit = (event, text) => {
    event.preventDefault();
    const wordsArray = wordsState[text];
    openPopup(wordsArray);
  };

  const TechData = [
    {
      id: 0,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M43.1,51.3c-0.1,0.1-0.3,0.1-0.4,0.2c-2,1.2-4.2,2.1-6.5,2.7c-0.2,0.1-0.5,0.3-0.6,0.6c-0.5,1.3-1,2.6-1.5,4c-0.1,0.3-0.3,0.4-0.6,0.4c-2.3,0-4.6,0-7,0c-0.4,0-0.5-0.1-0.6-0.5c-0.5-1.3-1-2.6-1.5-3.9c-0.1-0.3-0.3-0.5-0.7-0.6c-2.2-0.5-4.3-1.4-6.3-2.6c-0.3-0.2-0.6-0.2-1-0.1c-1.3,0.6-2.5,1.1-3.8,1.7c-0.3,0.1-0.5,0.1-0.7-0.1c-1.6-1.7-3.3-3.3-4.9-4.9c-0.3-0.3-0.3-0.5-0.1-0.8c0.6-1.3,1.2-2.5,1.7-3.8c0.1-0.2,0.1-0.6,0-0.9c-1.1-2-2.1-4.1-2.6-6.4c-0.1-0.4-0.3-0.6-0.6-0.7c-1.3-0.5-2.6-1-3.9-1.5C1,34,0.9,33.8,0.9,33.5c0-2.3,0-4.6,0-7c0-0.4,0.1-0.5,0.5-0.6c1.3-0.5,2.6-1,3.9-1.5c0.2-0.1,0.5-0.3,0.5-0.6c0.6-2.3,1.5-4.4,2.7-6.5c0.1-0.2,0.1-0.6,0-0.8c-0.5-1.3-1.1-2.6-1.7-3.9c-0.1-0.3-0.1-0.5,0.1-0.7c1.7-1.6,3.3-3.3,4.9-4.9c0.3-0.3,0.5-0.3,0.8-0.1c1.3,0.6,2.5,1.2,3.8,1.7c0.2,0.1,0.6,0.1,0.9,0c2-1.2,4.2-2.1,6.4-2.6c0.2-0.1,0.5-0.3,0.6-0.6c0.5-1.3,1-2.6,1.5-4C26,1,26.2,0.9,26.5,0.9c2.3,0,4.6,0,7,0c0.4,0,0.5,0.1,0.6,0.5c0.5,1.3,1,2.6,1.5,3.9c0.1,0.2,0.3,0.5,0.6,0.5c2.3,0.6,4.4,1.5,6.5,2.7c0.2,0.1,0.6,0.1,0.8,0c1.3-0.5,2.6-1.1,3.9-1.7c0.3-0.1,0.5-0.1,0.7,0.1c1.6,1.7,3.3,3.3,4.9,4.9c0.3,0.3,0.3,0.5,0.1,0.8c-0.6,1.3-1.2,2.5-1.7,3.8c-0.1,0.2-0.1,0.6,0,0.9c1.1,2,2.1,4.1,2.6,6.4c0.1,0.4,0.3,0.6,0.6,0.7c1.3,0.5,2.6,1,3.9,1.5c0.3,0.1,0.4,0.3,0.4,0.6c0,2.3,0,4.6,0,7c0,0.4-0.1,0.5-0.5,0.6c-1.3,0.5-2.6,1-3.9,1.5c-0.3,0.1-0.5,0.3-0.6,0.7c-0.6,2.2-1.4,4.4-2.6,6.3c-0.2,0.3-0.2,0.6,0,1c0.6,1.3,1.1,2.5,1.7,3.8c0.1,0.3,0.1,0.5-0.1,0.7c-1.7,1.6-3.3,3.3-4.9,4.9c-0.3,0.3-0.5,0.3-0.8,0.1c-1.2-0.6-2.5-1.1-3.7-1.7C43.5,51.4,43.3,51.4,43.1,51.3z M21.1,45.8c7.3,4.2,17.6,2.9,23.5-5c5.7-7.7,4.5-18.4-2.8-24.7c-7.2-6.1-18.1-5.6-24.7,1.1C10.5,24,11,33.4,14,38.3c0.1-0.2,0.3-0.3,0.4-0.5c2.7-2.7,5.3-5.3,8-8c0.5-0.5,0.6-0.5,1.1,0c2.1,2.1,4.2,4.2,6.3,6.3c0.5,0.5,0.5,0.7,0,1.2c-2.7,2.7-5.4,5.4-8.1,8.1C21.6,45.5,21.4,45.6,21.1,45.8z M15.9,41.4c2.3-2.5,4.6-4.8,6.9-7.3c1,1,1.8,1.8,2.6,2.6c0.5,0.5,1.1,0.6,1.5,0.2c0.4-0.4,0.4-1-0.1-1.5c-0.8-0.8-1.7-1.7-2.5-2.5c-1.4-1.4-1.5-1.4-2.8,0c-2.2,2.3-4.4,4.6-6.7,7C15,40.2,15.3,40.7,15.9,41.4z" />
            <path d="M31.1,34.6c-0.4-0.5-0.9-0.9-1.3-1.3c0.1-0.1,0.2-0.3,0.4-0.4c1.6-1.6,3.3-3.3,4.9-4.9c0.5-0.5,1-0.6,1.6-0.4c0.6,0.2,1.2,0.3,1.7,0.5c0.7,0.2,1.3,0.3,2-0.1c0.9-0.6,2.2,0,2.6,1c0.5,1,0,2.2-0.9,2.7c-1,0.5-2.2,0.1-2.7-0.9c-0.2-0.4-0.5-0.6-0.9-0.7c-0.7-0.2-1.5-0.6-2.1-0.5c-0.6,0.2-1.1,1-1.7,1.5c-1.2,1.1-2.3,2.3-3.5,3.5C31.2,34.5,31.2,34.6,31.1,34.6z" />
            <path d="M26.3,29.8c-0.5-0.5-0.9-0.9-1.4-1.4c1.1-1.1,2.2-2.2,3.4-3.4c0.5-0.5,0.9-1,1.4-1.4c0.4-0.3,0.4-0.6,0.3-1.1c-0.1-0.3-0.2-0.7-0.3-1c-0.1-0.7-0.4-1.2-1.1-1.6c-1-0.5-1.1-1.9-0.5-2.8c0.6-0.9,1.8-1.1,2.8-0.5c0.9,0.6,1.2,1.8,0.6,2.8c-0.3,0.4-0.3,0.7-0.2,1.1c0.3,0.9,0.5,1.7,0.7,2.6c0.1,0.3,0,0.8-0.2,1C30,26.1,28.2,27.9,26.3,29.8z" />
            <path d="M28.9,32.3c-0.5-0.5-1-0.9-1.5-1.4c0.6-0.6,1.2-1.1,1.7-1.7c1.8-1.8,3.5-3.5,5.3-5.3c0.2-0.2,0.3-0.5,0.3-0.8c0-1.2,0.9-2.1,2.1-2.1c1.2,0,2,0.9,2,2.1c0,1.2-1,2-2.2,1.9c-0.4,0-0.6,0.1-0.9,0.3c-2.1,2.1-4.3,4.3-6.4,6.4C29.1,32,29,32.2,28.9,32.3z" />
          </g>
        </svg>
      ),
      title: "Power Aware Verification",
    },
    {
      id: 1,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M1.6,39.9c0-0.2,0-0.5,0-0.7c0-10.6,0-21.2,0-31.8c0-2.7,1.5-4.2,4.2-4.2c16.3,0,32.5,0,48.8,0c2.7,0,4.2,1.5,4.2,4.2c0,10.6,0,21.2,0,31.8c0,0.2,0,0.4,0,0.6C39.7,39.9,20.7,39.9,1.6,39.9z M43,34.8c-0.6,0.1-1,0.2-1.4,0.2c-0.6,0.1-1,0.5-0.9,1.1c0.1,0.5,0.5,0.8,1.1,0.7c1.2-0.2,2.3-0.3,3.5-0.5c0.7-0.1,0.9-0.5,0.9-1.1c-0.1-1.1-0.3-2.3-0.5-3.4c-0.1-0.7-0.5-1-1.1-0.9c-0.5,0.1-0.8,0.6-0.7,1.2c0.1,0.4,0.1,0.8,0.2,1.3c-1-0.6-1.8-1.1-2.7-1.6c-0.4-0.2-0.5-0.4-0.5-0.9c0-3.6,0-7.1,0-10.7c0-0.9-0.1-1.1-1-1.3c-2.8-1-5.5-1.9-8.3-2.9c-0.4-0.1-0.5-0.3-0.5-0.7c0-0.8,0-1.7,0-2.5c0-0.7,0-1.4,0-2.1c0.1,0,0.1-0.1,0.2-0.1c0.3,0.3,0.6,0.6,0.9,0.9c0.4,0.4,1,0.4,1.3,0.1c0.4-0.4,0.4-0.9-0.1-1.4c-0.8-0.8-1.6-1.7-2.5-2.5c-0.5-0.5-0.9-0.5-1.4,0c-0.8,0.8-1.7,1.6-2.5,2.5c-0.4,0.5-0.5,0.9-0.1,1.3c0.4,0.4,0.9,0.4,1.4-0.1c0.3-0.3,0.6-0.6,0.9-0.9c0,0,0.1,0,0.1,0.1c0,0.2,0,0.3,0,0.5c0,1.4,0,2.7,0,4.1c0,0.4-0.1,0.6-0.5,0.8c-2.7,0.9-5.4,1.9-8.1,2.8c-1,0.4-1.1,0.4-1.1,1.5c0,3.5,0,7,0,10.6c0,0.2,0,0.5-0.1,0.6c-1,0.6-2,1.2-3.1,1.9c0.1-0.6,0.2-1,0.2-1.4c0.1-0.6-0.2-1-0.7-1.1c-0.5-0.1-1,0.2-1.1,0.8c-0.2,1.2-0.4,2.4-0.5,3.6c-0.1,0.7,0.2,1,0.9,1.1c1.1,0.2,2.3,0.3,3.4,0.5c0.6,0.1,1.1-0.2,1.1-0.7c0.1-0.5-0.2-1-0.9-1.1c-0.4-0.1-0.9-0.1-1.4-0.2c1.1-0.6,2-1.2,2.9-1.7c0.3-0.2,0.6-0.2,1-0.1c2.8,1,5.5,2,8.3,2.9c0.4,0.1,0.9,0.1,1.3,0c2.8-0.9,5.5-1.9,8.3-2.9c0.2-0.1,0.5-0.1,0.7,0C40.9,33.5,41.9,34.2,43,34.8z M12.1,6.8c-1,0-2.1,0-3.1,0c-0.9,0-1.8,0-2.7,0c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.3,0.9,0.9,0.9c0.2,0,0.3,0,0.5,0c2.8,0,5.7,0,8.5,0c0.8,0,1.7,0,2.5,0c0.8,0,1.2-0.7,0.9-1.3c-0.2-0.4-0.6-0.5-1-0.5C15.9,6.8,14,6.8,12.1,6.8z M10.2,10.8c-1.2,0-2.4,0-3.6,0c-0.7,0-1.1,0.3-1.1,0.9c0,0.6,0.4,0.9,1.1,0.9c2.4,0,4.8,0,7.1,0c0.7,0,1.1-0.3,1.1-0.9c0-0.6-0.4-0.9-1.1-0.9C12.5,10.8,11.3,10.8,10.2,10.8z" />
            <path d="M1.6,41.8c19.1,0,38.1,0,57.2,0c-0.1,1.1,0,2.2-0.2,3.2c-0.3,1.6-1.8,2.7-3.5,2.7c-1.4,0-2.8,0-4.2,0c-15.1,0-30.2,0-45.3,0c-2.2,0-3.7-1.3-4-3.4C1.6,43.5,1.6,42.7,1.6,41.8z M31.1,44.7c0-0.5-0.4-0.9-0.9-0.9c-0.5,0-0.9,0.4-0.9,0.9c0,0.5,0.4,0.9,0.9,0.9C30.7,45.6,31.1,45.2,31.1,44.7z" />
            <path d="M30.2,56.7c-3.9,0-7.8,0-11.8,0c-0.2,0-0.5,0-0.7,0c-0.5-0.1-0.8-0.5-0.8-1c0-0.5,0.3-0.8,0.8-0.9c0.2,0,0.3,0,0.5,0c7.9,0,15.8,0,23.8,0c0.2,0,0.3,0,0.5,0c0.5,0.1,0.8,0.4,0.9,0.9c0,0.5-0.3,0.9-0.8,1c-0.2,0-0.4,0-0.6,0C38,56.7,34.1,56.7,30.2,56.7z" />
            <path d="M37.1,53c-4.6,0-9.2,0-13.8,0c0.5-1.1,0.9-2.2,1.4-3.3c0-0.1,0.3-0.2,0.4-0.2c3.4,0,6.8,0,10.3,0c0.1,0,0.4,0.1,0.4,0.2C36.2,50.8,36.6,51.8,37.1,53z" />
            <path d="M29.2,33.9c-1.3-0.5-2.6-0.9-3.9-1.4c-1.2-0.4-2.4-0.8-3.6-1.3c-0.2-0.1-0.4-0.3-0.4-0.4c0-3.2,0-6.4,0-9.7c0.2,0,0.3,0.1,0.5,0.1c2.4,0.8,4.7,1.6,7.1,2.5c0.2,0.1,0.4,0.3,0.4,0.5c0,3.1,0,6.3,0,9.4C29.3,33.8,29.3,33.8,29.2,33.9z" />
            <path d="M39,21.2c0,0.2,0,0.3,0,0.5c0,3,0,6,0,9c0,0.3,0,0.5-0.4,0.6c-2.4,0.8-4.9,1.7-7.3,2.6c-0.1,0-0.1,0-0.2,0c0-0.2,0-0.3,0-0.5c0-3,0-6,0-8.9c0-0.3,0-0.5,0.4-0.7c2.4-0.8,4.9-1.7,7.3-2.5C38.8,21.2,38.9,21.2,39,21.2z" />
            <path d="M23.2,19.9c0.8-0.3,1.4-0.5,2-0.7c1.5-0.5,3.1-1.1,4.6-1.6c0.2-0.1,0.5-0.1,0.7,0c2.2,0.7,4.3,1.5,6.5,2.2c0.1,0,0.1,0.1,0.3,0.2c-1.6,0.6-3.2,1-4.6,1.7c-1.6,0.7-3.1,0.7-4.7,0C26.4,20.9,24.8,20.5,23.2,19.9z" />
          </g>
        </svg>
      ),
      title: "Performance Tests Verification",
    },
    {
      id: 2,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M58.8,38.4c0,2.3,0,4.6,0,6.9c-1.1,0-2.2,0-3.4,0c0-1.2,0-2.3,0-3.4c-1.7,0-3.4,0-5.1,0c0,2.8,0,5.6,0,8.5c-2.9,0-5.6,0-8.4,0c0,1.7,0,3.4,0,5.1c1.1,0,2.2,0,3.4,0c0,1.2,0,2.3,0,3.4c-2.3,0-4.6,0-6.9,0c0-0.1,0-0.2,0-0.3c0-7.1,0-14.2,0-21.3c0-0.1,0-0.3,0-0.5c-0.2,0-0.4,0-0.6,0c-3.6,0-7.2,0-10.9,0c-0.4,0-0.6-0.1-0.8-0.5c-0.9-1.8-2.4-2.8-4.5-2.9c-2.5-0.1-4.7,1.8-5.1,4.2c-0.4,2.5,1.1,4.9,3.5,5.7c2.4,0.8,5-0.4,6.1-2.6c0.2-0.4,0.4-0.6,0.9-0.5c2.5,0,5,0,7.5,0c0.2,0,0.4,0,0.6,0c0,5.7,0,11.3,0,16.9c-1.1,0-2.2,0-3.3,0c0-2.2,0-4.5,0-6.7c-1.2,0-2.2,0-3.4,0c0,2.3,0,4.5,0,6.7c-1.1,0-2.2,0-3.4,0c0-2.2,0-4.5,0-6.7c-1.2,0-2.3,0-3.4,0c0,2.8,0,5.6,0,8.4c-2.3,0-4.6,0-6.9,0c0-1.1,0-2.2,0-3.4c1.2,0,2.3,0,3.4,0c0-1.7,0-3.4,0-5.1c-2.8,0-5.6,0-8.5,0c0-2.8,0-5.6,0-8.5c-1.7,0-3.4,0-5.1,0c0,1.1,0,2.2,0,3.4c-1.2,0-2.3,0-3.4,0c0-2.3,0-4.6,0-6.9c2.8,0,5.6,0,8.4,0c0-1.1,0-2.2,0-3.4c-2.3,0-4.5,0-6.7,0c0-1.1,0-2.2,0-3.4c2.3,0,4.5,0,6.7,0c0-1.1,0-2.2,0-3.3c-2.3,0-4.5,0-6.7,0c0-1.1,0-2.2,0-3.4c2.2,0,4.5,0,6.7,0c0-1.2,0-2.3,0-3.5c-2.8,0-5.6,0-8.4,0c0-2.3,0-4.6,0-6.9c1.1,0,2.2,0,3.4,0c0,1.2,0,2.3,0,3.4c1.7,0,3.4,0,5.1,0c0-2.8,0-5.6,0-8.5c2.9,0,5.6,0,8.4,0c0-1.7,0-3.4,0-5.1c-1.1,0-2.2,0-3.4,0c0-1.2,0-2.3,0-3.4c2.3,0,4.6,0,6.9,0c0,0.1,0,0.1,0,0.2c0,8.3,0,16.5,0,24.8c0,0.1,0,0.3,0.1,0.4c2.7,0,5.4,0,8.1,0c0.5,0,0.7,0.1,0.9,0.6c1,2.1,3.3,3.2,5.6,2.7c2.2-0.5,3.9-2.5,4-4.8c0.1-2.2-1.4-4.3-3.6-5c-2.4-0.7-4.9,0.4-6.1,2.7c-0.1,0.2-0.3,0.4-0.4,0.4c-1.7,0-3.4,0-5.1,0c0-6.8,0-13.6,0-20.3c1.1,0,2.2,0,3.3,0c0,2.3,0,4.5,0,6.7c1.2,0,2.2,0,3.4,0c0-2.3,0-4.5,0-6.7c1.1,0,2.2,0,3.4,0c0,2.2,0,4.5,0,6.7c1.2,0,2.3,0,3.4,0c0-2.8,0-5.6,0-8.4c1.7,0,3.4,0,5.1,0c0,1.1,0,2.2,0,3.4c-0.5,0-1.1,0-1.6,0c0,1.7,0,3.4,0,5.1c2.8,0,5.6,0,8.5,0c0,2.8,0,5.6,0,8.4c1.7,0,3.4,0,5.1,0c0-1.1,0-2.2,0-3.4c1.2,0,2.3,0,3.4,0c0,2.3,0,4.6,0,6.9c-2.8,0-5.6,0-8.4,0c0,1.2,0,2.3,0,3.5c2.3,0,4.5,0,6.7,0c0,1.1,0,2.2,0,3.4c-2.3,0-4.5,0-6.7,0c0,1.1,0,2.2,0,3.3c2.3,0,4.5,0,6.7,0c0,1.1,0,2.2,0,3.4c-2.2,0-4.5,0-6.7,0c0,1.2,0,2.3,0,3.4C53.2,38.4,56,38.4,58.8,38.4z" />
            <path d="M35.1,23.2c0.9,0,1.7,0.7,1.7,1.6c0,0.9-0.8,1.7-1.7,1.7c-0.9,0-1.7-0.8-1.7-1.7C33.4,24,34.2,23.2,35.1,23.2z" />
            <path d="M23.3,38.4c0,0.9-0.7,1.7-1.6,1.7c-1,0-1.7-0.7-1.7-1.7c0-0.9,0.8-1.7,1.7-1.7C22.5,36.8,23.2,37.5,23.3,38.4z" />
          </g>
        </svg>
      ),
      title: "VIP Development",
    },
    {
      id: 3,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M1.3,25.8c0-2.1,0-4.1,0-6.2c0.3-0.8,0.9-1.3,1.8-1.4c0-0.3,0-0.5,0-0.7c0-3.9,0-7.8,0-11.7c0-1.3,0.7-2,2-2c1.5,0,3.1,0,4.6,0c0.2,0,0.4,0,0.5,0c0.3-1.3,0.9-1.8,2.2-1.8c2.2,0,4.3,0,6.5,0c1.4,0,1.9,0.4,2.3,1.8c1.7,0,3.4,0,5,0c1.4,0,2.1,0.7,2.1,2.1c0,3.9,0,7.7,0,11.6c0,0.2,0,0.4,0,0.7c1.4,0.3,1.8,0.9,1.8,2.3c0,1.6,0,3.2,0,4.8c0,0.3,0,0.5-0.1,0.8c-1.2,4.1-2.3,8.3-3.5,12.4c-0.3,1-0.9,1.4-1.9,1.4c-0.5,0-1.1,0-1.6,0c0,1.8,0,3.6,0,5.3c0,1.1-0.8,1.8-1.8,1.9c-0.5,0-0.9,0-1.5,0c0.8,1.9,2.1,3.3,4.1,3.4c2.1,0.2,4.4,0.3,6.5-0.1c5.3-0.9,8.9-5.3,8.9-10.7c0-5.8,0-11.7,0-17.5c0-1.2,0.1-2.4,0.3-3.6c1.4-8.1,8.8-14.4,17.1-14.6c1.1,0,1.9,0.3,2.4,1.4c0,1.5,0,3,0,4.5c-0.4,1-1.2,1.4-2.3,1.4c-1,0-1.9,0.2-2.9,0.5c-4.4,1.4-7.4,5.5-7.5,10.1c0,5.9,0,11.9,0,17.8c0,1.4-0.2,2.9-0.5,4.3c-1.6,7.2-7.6,12.8-14.9,13.7c-2.1,0.3-4.3,0.2-6.4,0.2c-5.5,0-10.3-3.7-11.9-8.9c-0.2-0.6-0.3-1.2-0.5-1.9c-0.6,0-1.3,0-1.9,0c-1,0-1.7-0.8-1.8-1.8c0-0.8,0-1.6,0-2.4c0-1,0-2,0-3c-0.6,0-1.1,0-1.6,0c-1.1,0-1.7-0.5-2-1.5c-0.6-2.2-1.3-4.5-1.9-6.7C2.4,29.7,1.8,27.7,1.3,25.8z M6.7,7.5c0,3.6,0,7.2,0,10.7c2.4,0,4.8,0,7.1,0c0-1.2,0-2.3,0-3.6c-0.6,0-1.1,0-1.7,0c-1.1,0-1.8-0.8-1.9-1.9c0-0.4,0-0.8,0-1.2c0-1.4,0-2.7,0-4.1C9,7.5,7.9,7.5,6.7,7.5z M21,7.5c0,1.8,0,3.5,0,5.2c0,1.2-0.7,2-1.9,2c-0.5,0-1.1,0-1.6,0c0,1.2,0,2.4,0,3.5c2.4,0,4.8,0,7.1,0c0-3.6,0-7.1,0-10.7C23.4,7.5,22.3,7.5,21,7.5z M15.6,25.5c-1.7,0-3.5,0-5.2,0c-1.2,0-2,0.8-2,1.8c0,1,0.8,1.8,2,1.8c3.5,0,6.9,0,10.4,0c1.2,0,2-0.7,2-1.8c0-1.1-0.8-1.8-2-1.8C19.1,25.5,17.4,25.5,15.6,25.5z M17.4,11.1c0-1.8,0-3.6,0-5.3c-1.2,0-2.4,0-3.5,0c0,1.8,0,3.6,0,5.3C15.1,11.1,16.2,11.1,17.4,11.1z" />
          </g>
        </svg>
      ),
      title: "Formal Verification",
    },
    {
      id: 4,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M45.5,43.1c0.6,0.5,1.2,0.9,1.7,1.4c0.8,0.7,1.7,0.9,2.7,0.4c1-0.5,1.5-1.3,1.5-2.4c0-1.7,0-3.4,0-5.2c0.2,0,0.4,0,0.6,0c1.4,0,2.9,0,4.3,0c1.2,0,1.7,0.5,1.7,1.7c0,6.1,0,12.2,0,18.2c0,1.2-0.5,1.7-1.7,1.7c-7.2,0-14.4,0-21.7,0c-1.2,0-1.7-0.5-1.7-1.7c0-6.1,0-12.2,0-18.3c0-1.2,0.5-1.7,1.7-1.7c1.6,0,3.2,0,4.9,0c0,0.4,0,0.7,0,1.1c0,1.4,0,2.9,0,4.3c0,1,0.5,1.8,1.4,2.2c0.9,0.4,1.8,0.4,2.5-0.2C44.2,44.2,44.8,43.6,45.5,43.1z M40,54.9c0.8,0,1.6,0,2.3,0c0.5,0,0.7-0.2,0.7-0.6c0-0.7,0-1.4,0-2.1c0-0.5-0.2-0.7-0.7-0.7c-1.5,0-3.1,0-4.6,0c-0.5,0-0.7,0.2-0.7,0.7c0,0.7,0,1.4,0,2.1c0,0.5,0.2,0.7,0.7,0.6C38.5,54.9,39.3,54.9,40,54.9z" />
            <path d="M4.4,53.3C4.9,47.1,5.5,41,6.1,34.7c1.9,1.6,4,2.5,6.4,2.4c2.4,0,4.5-0.8,6.4-2.5c0.6,6.3,1.1,12.4,1.7,18.6C15.2,53.3,9.8,53.3,4.4,53.3z" />
            <path d="M13.4,18c4.7-3.8,9.3-7.5,14-11.3c0.7,3.4,2.6,5.4,6,6c-3.8,4.7-7.5,9.3-11.3,14C21.2,21.7,18.4,18.9,13.4,18z" />
            <path d="M4.8,27.6c0-4.3,3.4-7.7,7.7-7.7c4.2,0,7.7,3.4,7.7,7.7c0,4.3-3.5,7.7-7.7,7.7C8.2,35.3,4.8,31.8,4.8,27.6z M15.8,27.6c0-1.8-1.4-3.3-3.2-3.3c-1.8,0-3.2,1.4-3.3,3.2c0,1.8,1.4,3.3,3.2,3.3C14.3,30.8,15.7,29.4,15.8,27.6z" />
            <path d="M41.7,32.9c-1.8-0.8-4-3.9-3.4-7.5c0.6-3.3,3.5-5.8,6.9-5.9c3.5-0.1,6.6,2.2,7.4,5.5c0.8,3.1-0.7,6.7-3.3,7.9c0-0.3,0-0.6,0-0.9c0-1.5,0-3.1,0-4.6c0-0.3-0.1-0.5-0.4-0.7c-1-0.6-2.1-1.2-3.1-1.8c-0.2-0.1-0.5-0.1-0.7,0c-1,0.6-2,1.2-3.1,1.7c-0.3,0.2-0.4,0.4-0.4,0.7c0,1.6,0,3.3,0,4.9C41.7,32.5,41.7,32.6,41.7,32.9z" />
            <path d="M12.5,55.3c3.2,0,6.5,0,9.7,0c0.7,0,0.8,0.1,0.8,0.9c0,0.7,0,1.4,0,2.2c0,0.5-0.2,0.7-0.7,0.7c-6.6,0-13.3,0-19.9,0c-0.5,0-0.7-0.2-0.7-0.7c0-0.8,0-1.5,0-2.3c0-0.7,0.1-0.8,0.8-0.8C6,55.3,9.2,55.3,12.5,55.3z" />
            <path d="M34.2,10.8c-2.7,0-4.9-2.2-4.9-4.9c0-2.7,2.2-4.9,4.9-4.9c2.7,0,4.9,2.2,4.9,4.9C39,8.6,36.9,10.8,34.2,10.8z M35.9,5.9c0-1-0.8-1.8-1.8-1.8c-1,0-1.7,0.8-1.8,1.7c0,1,0.8,1.8,1.8,1.8C35.1,7.7,35.9,6.9,35.9,5.9z" />
            <path d="M41.4,37.4c2.7,0,5.4,0,8.1,0c0,1.5,0,2.9,0,4.3c0,0.3,0,0.6,0,0.9c-0.1,0.2-0.2,0.6-0.4,0.7c-0.2,0.1-0.5,0-0.7-0.1c-0.8-0.6-1.6-1.2-2.3-1.9c-0.4-0.4-0.8-0.4-1.3,0c-0.7,0.6-1.5,1.3-2.3,1.8c-0.2,0.2-0.6,0.3-0.8,0.2c-0.2-0.1-0.3-0.5-0.4-0.7C41.4,40.8,41.4,39.1,41.4,37.4z" />
            <path d="M40.7,7.7c1.8,2.2,3.6,4.4,5.4,6.6c-1.7,0.3-3.6-0.5-5,1.2c-1.4-1.1-2.7-2.2-4.1-3.4C38.8,11.1,40.1,9.8,40.7,7.7z" />
            <path d="M42.3,17.9c-0.2-1.2,0.3-1.7,1.5-1.7c1.1,0,2.2,0,3.3,0c1.2,0,1.7,0.5,1.5,1.7c-1-0.1-2.1-0.4-3.1-0.4C44.4,17.6,43.4,17.8,42.3,17.9z" />
          </g>
        </svg>
      ),
      title: "SystemC/TLM Modelling",
    },
    {
      id: 5,
      svg: (
        <svg
          width="35"
          height="35"
          viewBox="0 0 60 60"
          fill="#f50057"
          stroke="#000000"
          stroke-width="0.85"
          xmlns="http://www.w3.org/2000/svg"
        >
          <g>
            <path d="M38.9,46.4c1,1,2,2,3,3c-1.5,0.9-3.1,1.7-4.8,2.2c-0.9,0.3-1.9,0.5-2.9,0.8c-0.9,0.2-1.1,0.5-1.1,1.4c0,1.7,0,3.4,0,5.2c-2.1,0-4.1,0-6.2,0c0-1,0-1.9,0-2.9c0-0.8,0-1.6,0-2.5c0-0.7-0.3-1.1-1-1.2c-3.2-0.6-6.1-1.8-8.8-3.6c-0.7-0.5-1.1-0.4-1.7,0.2c-1.2,1.2-2.5,2.5-3.6,3.7c-1.5-1.5-2.9-2.9-4.4-4.4c1.1-1.1,2.3-2.3,3.5-3.5c0.8-0.8,0.8-1.1,0.2-2c-1.7-2.6-2.9-5.4-3.5-8.5c-0.2-0.9-0.5-1.1-1.4-1.1c-1.7,0-3.4,0-5.2,0C1,31,1,29,1,26.9c1.7,0,3.4,0,5.1,0c1.1,0,1.3-0.2,1.6-1.3c0.6-3,1.8-5.8,3.5-8.4c0.5-0.8,0.5-1.2-0.2-1.8c-1.2-1.2-2.4-2.4-3.6-3.6c1.5-1.5,2.9-2.9,4.4-4.4c1.2,1.2,2.4,2.4,3.6,3.6c0.7,0.7,1,0.8,1.9,0.2c2.6-1.7,5.4-2.9,8.5-3.5c0.9-0.2,1.1-0.5,1.1-1.4c0-1.7,0-3.4,0-5.2c2.1,0,4.1,0,6.2,0c0,0.9,0,1.9,0,2.8c0,0.9,0,1.7,0,2.6c0,0.6,0.3,1,0.9,1.1c3.2,0.6,6.2,1.8,8.9,3.7c0.6,0.4,1.1,0.4,1.6-0.2c1.2-1.2,2.5-2.5,3.6-3.7c1.5,1.5,2.9,2.9,4.4,4.4c-1.1,1.1-2.2,2.2-3.4,3.4c-0.9,0.9-1,1.1-0.2,2.3c1.7,2.5,2.8,5.3,3.4,8.3c0.2,0.9,0.5,1.1,1.4,1.1c1.7,0,3.4,0,5.2,0c0,2.1,0,4.1,0,6.2c-1.7,0-3.3,0-5,0c-1.2,0-1.4,0.1-1.6,1.3c-0.5,2.7-1.5,5.2-2.9,7.4c-1-1-2-2-3-3c2.6-5,3-10.3,0.9-15.8c-1.6-4-4.3-7.1-8.1-9.3C31.6,9.4,22,11,16.1,17.4c-6,6.6-6.5,16.3-1.3,23.5C19.9,48,30,51.2,38.9,46.4z" />
            <path d="M29,29c-0.9,0-1.8,0-2.7,0c-0.2,0-0.5-0.2-0.6-0.4c-1.6-1.6-3.2-3.2-4.8-4.8c-0.9-0.9-1.6-0.8-2.1,0.4C16,30.5,20.2,37.8,27,38.6c0.8,0.1,1.6,0.1,2.4,0c0.9-0.1,1.8,0.1,2.5,0.7c1.8,1.8,3.6,3.6,5.4,5.5c-4.7,2.7-13.1,2.9-19-3c-6.1-6.1-6.5-15.7-1.1-22.3c5.4-6.6,15-7.9,22-3.2c7.2,4.9,9.2,14.1,5.6,21.2c-0.2-0.1-0.3-0.2-0.4-0.4c-1.6-1.6-3.1-3.2-4.7-4.7c-0.8-0.8-1.2-1.8-1.1-3c0.3-3.9-1.1-7.1-4.2-9.4c-3.2-2.3-6.7-2.6-10.3-1.1c-1,0.4-1.1,1.2-0.3,1.9c1.6,1.6,3.2,3.2,4.8,4.9c0.2,0.2,0.4,0.6,0.4,0.9C29,27.3,29,28.1,29,29z" />
            <path d="M20.3,26.2c1.4,1.4,2.8,2.8,4.2,4.2c0.5,0.5,0.9,0.7,1.6,0.7c1.2,0,2.5,0,3.7,0c0.9,0,1.3-0.4,1.3-1.3c0-1.2,0-2.4,0-3.6c0-0.7-0.2-1.2-0.7-1.7c-1.2-1.2-2.4-2.4-3.7-3.6c-0.2-0.1-0.4-0.2-0.5-0.4c1.5-0.5,2.9-0.5,4.3-0.1c3.9,1,6.5,4.9,6.1,8.9c-0.2,1.8,0.4,3.3,1.7,4.6c5.1,5.1,10.2,10.2,15.3,15.3c1.4,1.4,2.9,2.9,4.3,4.4c0.9,0.9,1.1,2,0.8,3.2c-0.4,1.1-1.2,1.8-2.4,2.1c-1.2,0.2-2.1-0.2-3-1c-2.8-2.8-5.6-5.6-8.3-8.3c-3.7-3.7-7.4-7.4-11.1-11.1c-1.3-1.3-2.9-1.9-4.8-1.6c-5.4,0.6-10.1-4.7-8.8-10C20.2,26.5,20.3,26.4,20.3,26.2z M53.2,52c-0.3-0.4-0.4-0.7-0.7-1c-4-4-8-8-11.9-12c-0.1-0.1-0.3-0.3-0.4-0.4c-0.4-0.3-0.9-0.2-1.2,0.1c-0.4,0.4-0.4,0.8-0.1,1.3c0.1,0.2,0.3,0.3,0.4,0.5c3.9,3.9,7.8,7.8,11.8,11.8c0.2,0.2,0.4,0.4,0.6,0.5c0.3,0.1,0.7,0.1,1,0C52.8,52.7,52.9,52.3,53.2,52z M56.7,55.7c0-0.7-1.2-1.8-1.8-1.8c-0.7,0-1.3,0.9-0.8,1.5c0.3,0.5,0.7,0.9,1.2,1.2C55.8,57,56.7,56.4,56.7,55.7z M35.7,34.8c-0.1,0.1-0.5,0.3-0.7,0.5c-0.1,0.3-0.1,0.8,0,1.1c0.2,0.4,0.6,0.8,1,1c0.3,0.2,0.8,0.2,1.1,0c0.3-0.1,0.5-0.6,0.5-0.9C37.7,36,36.5,34.8,35.7,34.8z" />
          </g>
        </svg>
      ),
      title: "UVM Development",
    },
  ];
  return (
    <>
      <section class="wrapper-border bg-light mt-5">
        <BannerZoom images={images} heading1={heading1} heading2={heading2} />
      </section>
      <section class="wrapper-border mt-4 custom-width">
        <div
          style={{
            position: "fixed",
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            zIndex: -1,
          }}
        >
          <Player
            autoplay
            loop
            src={circle5}
            style={{
              width: "100%",
              height: "100%",
              objectFit: "cover",
            }}
          />
        </div>

        <div class="container py-10 py-md-10">
          <div class="row">
            <motion.div
              className="col-md-7 mb-1"
              ref={ref}
              initial="initial"
              animate={inView ? "visible" : "initial"}
              variants={variants2}
              transition={{ duration: 1, delay: 0.3 }}
            >
              <Player
                src={animation1}
                className="player"
                loop
                autoplay
                style={{ height: "600px", width: "100%" }}
              />
            </motion.div>
            <div class="col-md-5 mb-1 mt-4" style={{ color: "#407AFF" }}>
              <motion.div
                ref={ref1}
                initial="initial"
                animate={inView1 ? "visible" : "initial"}
                variants={variants1}
                transition={{ duration: 1, delay: 0.3 }}
                className="card ms-lg-13 AMS-at"
              >
                <div className="card-body p-2">
                  <div className="d-flex flex-row">
                    <div>
                      <h4 className="mb-1">DESIGN VERIFICATION FIELDS</h4>
                      <h5 className="mb-1">
                        We provide DESIGN VERIFICATION services in the the
                        following areas:
                      </h5>
                      <ul
                        className="fw-bold"
                        style={{ lineHeight: "1.5", letterSpacing: "1px" }}
                      >
                        <li>
                          IP and SOC level Verification Architecture development
                        </li>
                        <li>Test Bench development</li>
                        <li>Low power architecture and CPF/UPF flow setup</li>
                        <li>System Verilog/Specman/UVM</li>
                        <li>
                          Functional verification signoff (code coverage,
                          functional coverage, formal verification, assertion,
                          Gate-level simulation)
                        </li>
                        <li>Power aware Gate level Simulation</li>
                        <li>FPGA Emulation and SW Emulation</li>
                      </ul>
                    </div>
                  </div>
                </div>
              </motion.div>
            </div>
          </div>

          <motion.div
            ref={ref2}
            initial="initial"
            animate={inView2 ? "visible" : "initial"}
            variants={variants2}
            transition={{ duration: 1, delay: 0.3 }}
            className="card ms-lg-13 mt-1 mb-5 DV-at"
          >
            <div className="card-body p-1 mt-1">
              <div className="d-flex flex-row">
                <p
                  className="lead fw-bold text-center"
                  style={{
                    lineHeight: "1.4",
                    letterSpacing: "2px",
                    fontSize: "2rem",
                  }}
                >
                  To help our customers deliver complex designs within their
                  time, budget, and infrastructure constraints, we combine our
                  engineering, technological and industrial expertise with our
                  best practices (processes, methodologies, and tools) in
                  hardware design verification.
                </p>
              </div>
            </div>
          </motion.div>

          <DesignVeriOne />

          <div
            className="card mt-5 mb-5"
            style={{ boxShadow: "0 8px 12px rgba(0, 0, 0, 0.2)" }}
          >
            <div className="card-body" style={{ backgroundColor: "lightblue" }}>
              <motion.p
                className="lead fw-bold"
                ref={ref3}
                initial="hidden"
                animate={inView3 ? "visible" : "hidden"}
                variants={variants3}
                transition={{ duration: 2 }}
              >
                These VIPs are very easy to integrate and use in any
                verification environment. They can be used for directed testing
                or coverage driven testing to achieve maximum code and
                functional coverage. These VIPs reduce overall verification time
                and effort drastically.
              </motion.p>
            </div>
            <div className="card-footer">
              <div className="row gx-lg-12 gx-xl-12 gy-10 mb-5 mb-md-5 align-items-center">
                <div className="col-lg-3 col-md-3 col-sm-6">
                  <a
                    className="link-dark"
                    href="#"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => handleSubmit(e, "Methodology")}
                  >
                    <DesignVeriTwo heading1="Methodology" lottie2={lottie10} />
                  </a>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                  <a
                    className="link-dark"
                    href="#"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => handleSubmit(e, "Subsystem")}
                  >
                    <DesignVeriTwo heading1="Subsystem" lottie2={lottie10} />
                  </a>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                  <a
                    className="link-dark"
                    href="#"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => handleSubmit(e, "IPs")}
                  >
                    <DesignVeriTwo heading1="IPs" lottie2={lottie10} />
                  </a>
                </div>
                <div className="col-lg-3 col-md-3 col-sm-6">
                  <a
                    className="link-dark"
                    href="#"
                    style={{ textDecoration: "none" }}
                    onClick={(e) => handleSubmit(e, "AMS")}
                  >
                    <DesignVeriTwo heading1="AMS" lottie2={lottie10} />
                  </a>
                </div>
              </div>
            </div>
          </div>

          <div
            ref={ref4}
            style={{ color: "#407AFF" }}
            className={`d-flex justify-content-center align-items-center mt-0 ${
              inView4
                ? "animate__animated animate__fadeInRight animate__delay-0.5s"
                : ""
            }`}
          >
            <h2>Our Design Verification includes the following</h2>
          </div>
          <hr class="double my-10" />
          <div
            ref={ref5}
            className={`row gy-3 gx-xl-8 gayab ${
              inView5
                ? "animate__animated animate__fadeInUp animate__delay-0.5s"
                : ""
            }`}
          >
            <div className="col-lg-3">
              <AsicCard Data={TechData[0]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[1]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[2]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[3]} />
            </div>
          </div>
          <hr class="double my-8" />
          <div
            ref={ref6}
            className={`row gy-3 gx-xl-8 gayab ${
              inView6
                ? "animate__animated animate__fadeInUp animate__delay-0.8s"
                : ""
            }`}
          >
            <div className="col-lg-3">
              <AsicCard Data={TechData[4]} />
            </div>
            <div className="col-lg-3">
              <AsicCard Data={TechData[5]} />
            </div>
          </div>
          <hr class="double my-8" />
        </div>
        <AmsDataOne />
      </section>
      {isPopupVisible && (
        <Popup wordsArray={selectedWords} onClose={closePopup} />
      )}
    </>
  );
};

export default DesignVerification;
